import { Alert, Button as CloseButton, Typography } from "antd";
import {
	ButtonWrapper,
	FooterModalWrapper,
	SocialMediaWrapper,
	StyledForm,
	TextCol,
	Wrapper,
} from "./styles";
import { ErrorMessage } from "views/components/Message";
import { Form } from "views/components/common/Form";
import { Link } from "react-router-dom";
import { LoginModal as Modal } from "../../components/Popup/LoginModal";
import { ModalButton } from "../../../components/ModalButton";
import { Spacer } from "views/components/common/Spacer";
import { useLoginModalTicket } from "hooks/useLoginModalTicket";
import { useLoginModalWithProvider } from "hooks/useLoginModalWithProvider";
import { useState } from "react";
import Input from "views/components/common/Input/Input";
import React, { useEffect } from "reactn";
import SocialButton from "views/mobile/components/common/SocialButton";
const { Text } = Typography;

export const LoginModal = ({
	setWantTemporary,
	handleMeet,
	setIsVisibleConfirmationModal,
	visible,
	onClose,
	ticketAction,
	isActiveLoginModal,
	isSignUpModalActive,
	blockreservation,
	getReservation,
	openWithoutLoginModal,
	openRutUpdateModal,
	handleOpenUpdateRutModal,
	isRutRequired,
	setIsRutModalVisible,
	isDniRequired,
	fieldsAnswers,
	allowContinueWithTemp = true,
}) => {
	const [showLabel, setShowLabel] = useState(false);

	const [submit, success, loading, error] = useLoginModalTicket({
		onClose,
		getReservation,
		blockreservation,
		openRutUpdateModal,
		handleOpenUpdateRutModal,
		handleMeet,
		isRutRequired,
		isDniRequired,
		setIsRutModalVisible,
	});
	const [
		logIn,
		successProvider,
		loadingGoogle,
		errorProvider,
		loadingFacebook,
		loadingMicrosoft,
	] = useLoginModalWithProvider({
		onClose,
		getReservation,
		blockreservation,
		openRutUpdateModal,
		handleOpenUpdateRutModal,
		handleMeet,
		isRutRequired,
		isDniRequired,
		setIsRutModalVisible,
		fieldsAnswers,
	});

	useEffect(() => {
		if (success || successProvider) {
			return ticketAction();
		}
	}, [success, successProvider]);

	const [inputs, setInputs] = React.useState({});

	const onChangeInputs = ({ input, value }) => {
		setInputs((i) => ({ ...i, [input]: value }));
	};
	useEffect(() => {
		const timeout =
			loadingGoogle || loadingFacebook || loadingMicrosoft
				? setTimeout(
						() => setShowLabel(true),

						5000
				  )
				: null;

		return () => clearTimeout(timeout);
	}, [loadingGoogle, loadingFacebook, loadingMicrosoft]);

	const handlerFormsSubmit = () => {
		if (isRutRequired || isDniRequired) {
			onClose();
			return setIsRutModalVisible(true);
		}
		setWantTemporary(true);
		onClose();
	};

	return (
		<Modal visible={visible} onCancel={onClose}>
			<Wrapper>
				<TextCol>
					<Text className="title__login-modal">
						Bienvenido de nuevo
					</Text>
					<Spacer rows={1} />
					<Text className="modal__text-welcome" type="secondary">
						Inicia sesión y accede a tus sucursales favoritas,
						historial de tickets y más!
					</Text>
				</TextCol>

				<Spacer rows={1} />
				<Form className="form__login-modal">
					<StyledForm>
						<Input
							error={error}
							name="email"
							label="Email"
							placeholder=""
							type="email"
							onChange={onChangeInputs}
							required={true}
						/>
						{error && error.EmailMessage && (
							<span style={{ color: "red", fontSize: 12 }}>
								{error.EmailMessage}
							</span>
						)}
						<Spacer rows={1} />
						<Input
							error={error}
							name="password"
							label="Contraseña"
							placeholder=""
							type="password-default"
							onChange={onChangeInputs}
							required={true}
						/>
						{error && error.passwordMessage && (
							<span style={{ color: "red", fontSize: 12 }}>
								{error.passwordMessage}
							</span>
						)}
						<Spacer rows={0.5} />
						<p className="pass__recover ">
							<Link to="/recover">¿Olvidaste tu contraseña?</Link>
						</p>
					</StyledForm>
				</Form>
				<ButtonWrapper>
					<ModalButton
						onClick={() => submit(inputs)}
						loading={loading}
						type={"primary"}
						label="Iniciar Sesión"
					/>
				</ButtonWrapper>
				<Spacer rows={1} />
				<p>O ingresa con tus redes sociales</p>

				<SocialMediaWrapper>
					{/* <ErrorMessage error={errorProvider} /> */}
					{showLabel && (
						<Alert
							type={"success"}
							description={
								"Si no pudiste ingresar, actualiza la página e inténtalo de nuevo."
							}
						/>
					)}
					<Spacer rows={0.5} />

					{/* <SocialButton
						loading={loadingFacebook}
						onClick={logIn("facebook")}
						icon="facebook"
					/> */}
					<SocialButton
						loading={loadingGoogle}
						onClick={logIn("google")}
						icon="google"
					/>
					<SocialButton
						loading={loadingMicrosoft}
						onClick={logIn("microsoft")}
						icon="outlook"
					/>
				</SocialMediaWrapper>

				<Spacer rows={1.5} />
				<FooterModalWrapper>
					<div className="modal__registry-container">
						<span>
							Si no estás registrado,{" "}
							<a
								className="signup__already-registered-anchor"
								onClick={isSignUpModalActive}
							>
								crea tu cuenta
							</a>
						</span>
					</div>

					{allowContinueWithTemp && (
						<>
							<Spacer rows={1} />
							<p>Recuerda que también puedes</p>
							<div
								className="noregistry__ticket-label"
								onClick={() => {
									getReservation
										? handlerFormsSubmit()
										: openWithoutLoginModal();
								}}
								// onClick={() => setWantTemporary(true)}
							>
								Continuar sin registrarte
							</div>
						</>
					)}
				</FooterModalWrapper>
			</Wrapper>
		</Modal>
	);
};
